import Breadcrumb from 'components/breadcrumb'
import LoaderPopup from 'components/popUps/loaderInternalPopup'
import { useGeneralCfg } from 'contexts/general-context'
import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Slider from 'react-slick'

const SliderComp = ({ events }: { events: any[] }) => {
  const [isDragging, setIsDragging] = useState(false)
  const [startX, setStartX] = useState(0)

  const handleMouseDown = (e: React.MouseEvent) => {
    setStartX(e.clientX)
    setIsDragging(false)
  }

  const handleMouseMove = (e: React.MouseEvent) => {
    if (Math.abs(e.clientX - startX) > 10) {
      setIsDragging(true)
    }
  }

  const handleClickSlide = (e: React.MouseEvent) => {
    if (isDragging) {
      e.preventDefault()
    }
  }

  const responsive = [
    {
      breakpoint: 2024,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '28%'
      }
    },
    {
      breakpoint: 1900,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '22%'
      }
    },
    {
      breakpoint: 1750,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '25%'
      }
    },
    {
      breakpoint: 1650,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '23%'
      }
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '22%'
      }
    },
    {
      breakpoint: 1550,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '21%'
      }
    },
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '21%'
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '20%'
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: events?.length <= 1 ? 1 : 2,
        centerMode: true,
        centerPadding: events?.length <= 1 ? '0%' : '15%'
      }
    }
  ]

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '25%', // Ajusta el porcentaje según el tamaño deseado
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: responsive,
    afterChange: () => setIsDragging(false),
    beforeChange: () => setIsDragging(true)
  }

  const Card = ({ event }: { event: any }) => {
    return (
      <Link to="/events-info/1" onClick={(e) => handleClickSlide(e)}>
        <div className="events-info__card">
          <img src={`${event?.secondaryImageUrl}`} className="events-info__card__img" />
          <div className="events-info__card__container__text">
            <div>
              <h2 className="events-info__card__title">{event.name}</h2>
              <p className="events-info__card__date">Fecha</p>
              <p className="events-info__card__location">Ubicación</p>
            </div>

            <div className="flex justify-center items-center">
              <svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.90332 17.8761L12.8936 11.8858L6.90332 5.89551"
                  stroke="white"
                  strokeWidth="1.99676"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </Link>
    )
  }

  return (
    <div className="overflow-hidden w-screen">
      <Slider {...settings}>
        {events
          .filter((event) => event.featured)
          .map((event, index) => {
            return (
              <div key={index} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove}>
                <Card event={event} />
              </div>
            )
          })}
      </Slider>
    </div>
  )
}

const CardBottom = () => {
  return (
    <div className="events-info__bottom-content__card">
      <img
        src={`${AZURE_BASE_URL}/events/events-info-bottom-1.webp`}
        className="events-info__bottom-content__card__img"
      />
      <div className="events-info__bottom-content__card__container__texts">
        <div>
          <h2 className="events-info__bottom-content__card__title">AfterWork</h2>
          <p className="events-info__bottom-content__card__date">Fecha</p>
          <p className="events-info__bottom-content__card__location">Ubicación</p>
        </div>
        <div>
          <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.41406 17.5597L12.4043 11.5694L6.41406 5.5791"
              stroke="white"
              strokeWidth="1.99676"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

const BottomContent = () => {
  return (
    <div className="events-info__bottom-content">
      <h2 className="events-info__bottom-content__title">Otros eventos</h2>
      <div className="events-info__bottom-content__bar" />
      <div className="events-info__bottom-content__container-cards space-y-2">
        <CardBottom />
        <CardBottom />
      </div>
    </div>
  )
}

const EventsInfo = () => {
  const { events, getEvents, setEvents } = useGeneralCfg()

  const history = useHistory()

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const fetchedEvents = await getEvents()
        setEvents(fetchedEvents)
      } catch (error) {
        console.error('Error fetching events:', error)
      }
    }

    fetchEvents()
  }, [])

  if (!events) {
    return <LoaderPopup />
  }

  return (
    <div className="events-info">
      <div className="events-info__container">
        <div className="events-info__container__bc">
          <Breadcrumb text="Eventos" handleClick={() => history.goBack()} />
        </div>
      </div>
      <SliderComp events={events} />
      <div className="events-info__container">
        <BottomContent />
      </div>
    </div>
  )
}

export default EventsInfo
